module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/circle_sp-11acafc342a654049c25394c459cdb61.svg";